import { render, staticRenderFns } from "./EffectivateBillingTabParameters.vue?vue&type=template&id=5f796bc2"
import script from "./EffectivateBillingTabParameters.vue?vue&type=script&lang=ts"
export * from "./EffectivateBillingTabParameters.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports